import * as Contentful from 'contentful'
import { ComponentContentTypes, EntryTypeByContentType, FieldsOf } from '../types/content-types'

export const createEntry = <K extends ComponentContentTypes>(
  contentType: K,
  id: string,
  fields: FieldsOf<EntryTypeByContentType<K>>
): Contentful.Entry<FieldsOf<EntryTypeByContentType<K>>> => {
  const currentDateString = new Date().toISOString()
  return {
    update() {
      return Promise.resolve(this)
    },
    toPlainObject() {
      return this
    },
    metadata: {
      tags: [],
    },
    sys: {
      space: {
        sys: {
          type: 'Link',
          linkType: 'Space',
          id: 'space-placeholder',
        },
      },
      id,
      type: 'Entry',
      createdAt: currentDateString,
      updatedAt: currentDateString,
      revision: 0,
      contentType: {
        sys: {
          type: 'Link',
          linkType: 'ContentType',
          id: contentType,
        },
      },
      locale: 'en-US',
    },
    fields,
  }
}

// Example of unresolved links
// {
//   sys: { type: 'Link', linkType: 'Entry', id: 'c5aFP8nid2Ac679FM3sL5' }
// }
export const isUnresolvedLink = (entry: Contentful.Entry<unknown>): boolean => {
  return entry.sys && entry.sys.type === 'Link' && !entry.sys.contentType
}
